import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ActivatedRoute, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@Component({
  standalone: false,
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  returnUrl: string;
  userData;

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private route: ActivatedRoute,
    protected router: Router,
  ) { }


  ngOnInit(): void {
    this.oidcSecurityService.userData$.subscribe({
      next: (userData) => {
        if (userData && userData.userData) {
          this.userData = userData.userData;

          if ((this.router.url === '/' || this.router.url.startsWith('/?code=')) && this.userData.role && this.userData.role.some((role: string) => role.includes('adminpanel'))) {
            this.router.navigate(['/pages/dashboard']);
          } else {
            Sentry.captureException(new Error(`User ${this.userData.name} (${this.userData.nickname}) tried to access the admin panel without the required role.`), {
              level: 'error',
              extra: {
                username: this.userData.nickname,
              }
            });
          }
        }
      }
    })
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe({
      next: () => {
        console.log('Logged out');
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

}
